import { useCallback } from 'react';
import { useStore } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useModalMethods } from '../../shared/packages/modalManager';
import { modalNames } from '../../shared/configs/modal';
import { selectors, sliceKeys } from '../../model';

const selectCompanyId = selectors[sliceKeys.companies].selectCurrentId;

export const useOpenCreateDeskModal = () => {
  const { getState } = useStore();
  const { location } = useHistory();

  const { open } = useModalMethods();

  return useCallback(
    (props) => {
      open(modalNames.setDeskName, {
        serviceCompanyId:
          selectCompanyId(getState()) ?? location.state?.from?.companyId, // это не правильно, но пока так. Потом надо подумать, как гибко получать companyId
        ...props,
      });
    },
    [open, getState, location]
  );
};
